<template>
	<span class="icon-label" :class="statusClass">
<!--		<v-icon v-if="status  === workerStatus.Offline" class="">fas fa-stop</v-icon>-->
<!--		<v-icon v-if="status  === workerStatus.Unresponsive" class="">fas fa-times</v-icon>-->
<!--		<v-icon v-if="status  === workerStatus.Processing" class="">fa-spin fas fa-spinner</v-icon>-->
<!--		<v-icon v-if="status  === workerStatus.ShutdownReady" class="">far fa-stop</v-icon>-->
<!--		<v-icon v-if="status  === workerStatus.Waiting" class="">fas fa-ellipsis-h</v-icon>-->
<!--		<v-icon v-if="status  === workerStatus.Restarting" class="">fas fa-sync-alt</v-icon>-->
		{{statusText}}
	</span>
</template>

<script>
import { workerStatus } from "../../enums";

export default {
	props: {
		status: String,
	},
	computed: {
		statusClass() {
			return `workervm-status-${this.status}`;
		},
		statusText() {
			return this.status ? this.status : "Unknown";
		},
	},
	data() {
		return {
			workerStatus,
		};
	},
};
</script>
